import { BaseService } from '../../../infra/base.service'
import type { ProductInvoice } from './product-invoice'
import type { ProductInvoicesRepository } from './product-invoices.repository'

export class ProductInvoicesService extends BaseService<ProductInvoice> {
    constructor(private rep: ProductInvoicesRepository) {
        super(rep)
    }

    async upsert(dto: Partial<ProductInvoice>) {
        return await this.rep.upsert(dto)
    }
}
